import React from 'react';

const MatchingDetailsConfig = {
    settings: {
        layout: {
            config: {}
        }
    },
    routes: [
        {
            path: '/upload/matchingdetails',
            component: React.lazy(() => import('./MatchingDetails'))
        }
    ]
};

export default MatchingDetailsConfig;